/*eslint-disable */
import toast from '@/services/toast';
var $ = window.jQuery = require('jquery');
import {
  bus
} from '@/main';
export default {
  name: 'presentation-file-upload',
  components: {
  },
  props: [],
  data () {
    return {
      file:null,
      files:null,
      uploadAttachmentName:'',
      submitted:false,
      title:''
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    getPresentationDataListAgainMethod(){
      this.$store.dispatch('getPresentationListAction')
    },
    handleAttachmentUpload(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }else {
        this.uploadAttachmentName = '';
      }
    },
    cancelUploadingFileFun() {
      this.file = null
      this.files = null
      this.uploadAttachmentName = '';
    },
    uploadPresentationDataFileBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('title', this.title);
          formData.append('file', this.file);
          formData.append('filename', this.uploadAttachmentName);
          this.$store.dispatch('postPresentationListAction', formData)
            .then((res) => {  
              this.getPresentationDataListAgainMethod()
              toast.success('Presentation file uploaded');
              this.submitted =  false
              this.closeUploadPresentationDataPopup()
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.data || err.data.msg);
            })
          return;
        }
      })
    },
    closeUploadPresentationDataPopup(){
      bus.$emit('uploadPresentationDataBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
  }
}